import { Page } from '@touche-lts/panel-ui/dist'
import { ProductSKUsDTO } from 'models'
import { FetchOptions } from 'services'
import { PaginationSearchBase } from '..'
import { ProductSKUTableSearchProps, ProductSKUTableSortProps } from '.'
import {
    initialProductSKUTablePaginationProps, 
    initialProductSKUTableSearchProps, 
    skusTableNeedTimeoutProps
} from './products-skus-table-base.utils'
import { SKUFilterDTO } from 'models/skus-filter'

export class ProductsSKUTableBase extends PaginationSearchBase<
    ProductSKUTableSortProps,
    ProductSKUTableSearchProps,
    ProductSKUsDTO
> {
  constructor () {
    super({
        initialPaginationProps: initialProductSKUTablePaginationProps,
        initialSearchProps: initialProductSKUTableSearchProps,
        needTimeoutProps: skusTableNeedTimeoutProps
      })
  }

  public handleSearchResult = (data: Page<ProductSKUsDTO>): void => {
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get productSKUFilter (): SKUFilterDTO {
    return {
      status: this.searchProps.status,
      name: this.searchProps.name,
      minPrice: this.searchProps.minPrice,
      maxPrice: this.searchProps.maxPrice,
      minStock: this.searchProps.maxStock,
      maxStock: this.searchProps.maxStock,
      minSold: this.searchProps.minSold,
      maxSold: this.searchProps.maxSold,
      minRevenie: this.searchProps.minRevenue,
      maxRevenie: this.searchProps.maxRevenue
    }
  }
}
